<template>
    <div @click="openLocalePickerClicked">

        <!-- LOCALES SELECTED -->
        <div class="d-flex flex-wrap">

            <locale v-for="locale in data.locales" :key="locale.id"
                    color="grey darken-3"
                    :editable="false"
                    :data="locale"
                    :active="false"
                    :width="250"
            ></locale>
        </div>

        <!-- SELECT LOCALES IF NONE SELECTED -->
        <v-col v-if="data.locales && data.locales.length === 0">
            <v-list>
                <v-list-item @click="">
                    <v-list-item-avatar>
                        <v-icon>mdi-city</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        Click here to select
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>

        <!-- ERROR MESSAGE -->
        <span v-if="errorMessages.length>0" class="caption red--text text--lighten-1">
            {{errorMessages[0]}}
        </span>

        <locale-picker
                v-model="localePickerModel"
                :selected="data.locales"
                :locales="panelLocales"
                :translate="translate"
                @change="localesChanged"
        ></locale-picker>

    </div>

</template>

<script>

    import LocalePicker from './LocalePicker';
    import Locale from './Locale';

    export default {

        components: {
            Locale,
            LocalePicker,
        },

        props: {
            value: {
                type: Array | null,
                required: true
            },

            panelLocales: {
                type: Array | null,
                required: true,
            },

            errorMessages: {
                type: Array,
                required: false,
                default: () => []
            },

            selectedTitle: {
                type: String,
                required: false,
                default: 'Selected locales'
            },

            translate: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                localePickerModel: false,
                data: {
                    locales: [],
                },
            }
        },

        watch: {
            value(locales) {
                this.data.locales = [...locales];
            }
        },

        mounted() {
            if (this.value) this.data.locales = [...this.value];
        },

        methods: {

            localesChanged(locales) {
                this.data.locales = locales;
                this.$emit('input', this.data.locales);
            },

            openLocalePickerClicked() {
                this.localePickerModel = true;
            },
        }
    }
</script>
